/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/digipost'
export default icon
